<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  class="flex flex-col gap-4 p-4 bg-amber-50 rounded-lg border border-slate-200"
>
  <h4 class="text-body-md-600 text-surface-700 m-0">New Deposit</h4>

  <div class="grid grid-cols-2 gap-5">
    <!-- Left Column -->
    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Deposit Amount <span class="text-red-500">*</span></label>
        <currency-input-field
          formControlName="depositAmount"
          placeholder="Enter Amount"
          [currencySymbol]="currencySymbol()"
          styleClass="w-100"
          [min]="0"
        />
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Payment Amount <span class="text-red-500">*</span></label>
        <currency-input-field
          formControlName="paymentAmount"
          placeholder="Enter Amount"
          [currencySymbol]="currencySymbol()"
          styleClass="w-100"
          [min]="0"
        />
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Notes</label>
        <textarea
          pTextarea
          formControlName="notes"
          rows="4"
          placeholder="Add Notes"
          class="w-full rounded-md"
        ></textarea>
      </div>
    </div>

    <!-- Right Column -->
    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Due Date <span class="text-red-500">*</span></label>
        <p-datepicker
          appendTo="body"
          formControlName="depositDueDate"
          [showIcon]="true"
          iconDisplay="input"
          dateFormat="mm/dd/yy"
          placeholder="Select Date"
          styleClass="w-full"
        />
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Payment Date <span class="text-red-500">*</span></label>
        <p-datepicker
          appendTo="body"
          formControlName="paymentDate"
          [showIcon]="true"
          iconDisplay="input"
          dateFormat="mm/dd/yy"
          placeholder="Select Date"
          styleClass="w-full"
        />
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Payment Reference No.</label>
        <input
          pInputText
          formControlName="referenceNo"
          placeholder="e.g. 01785236"
          class="w-full rounded-md border-surface-300"
        />
      </div>

      <!-- Product Select -->
      <div class="flex flex-col gap-1">
        <label class="text-body-sm-500 text-surface-700">Product</label>
        <div class="flex items-center gap-2">
          <div
            class="flex flex-1 items-center gap-2 px-3 rounded-md border border-surface-300 bg-surface-50 min-h-[2.375rem] overflow-hidden"
          >
            <i class="pi pi-box text-surface-400 text-sm shrink-0"></i>
            <span class="text-body-sm text-surface-400 truncate">No product selected</span>
          </div>
          <p-button label="Select" icon="pi pi-search" severity="secondary" [outlined]="true" size="small" />
        </div>
      </div>
    </div>
  </div>

  <!-- Cheque Images -->
  <div class="flex flex-col gap-2">
    <label class="text-body-sm-500 text-surface-700">Cheque Images</label>

    <p-button
      label="Upload Images"
      icon="pi pi-upload"
      severity="secondary"
      [outlined]="true"
      size="small"
      type="button"
      (onClick)="chequeFileInput.click()"
    />

    <div class="flex flex-wrap gap-2 overflow-auto max-h-32 pt-2">
      @for (attachment of attachments(); track $index) {
        @if (attachment.file) {
          @if (attachment.s3Url) {
            <div class="relative group">
              <lib-image-preview [images]="getAttachmentImages()" title="Cheque Images">
                <img
                  [src]="attachment.s3Url"
                  alt="Cheque preview"
                  class="rounded-lg border border-surface-200 object-cover cursor-pointer"
                  style="height: 72px; width: 72px; object-fit: cover"
                />
              </lib-image-preview>
              <button
                type="button"
                class="absolute -top-1.5 -right-1.5 flex h-5 w-5 items-center border-none border-0 justify-center rounded-full bg-red-700 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                (click)="removeAttachment(attachment)"
              >
                <i class="pi pi-times text-xs"></i>
              </button>
            </div>
          } @else {
            <span
              class="inline-flex h-[72px] w-[72px] flex-col items-center justify-center gap-1 rounded-lg border border-primary-200 bg-primary-50 px-2 text-xs text-primary-700"
            >
              <i class="pi pi-spin pi-spinner text-sm"></i>
              <span>{{ attachment.progress }}%</span>
              <i
                class="pi pi-times text-xs cursor-pointer hover:text-red-500"
                (click)="removeAttachment(attachment)"
              ></i>
            </span>
          }
        } @else {
          <!-- Saved cheque image: no direct URL, fetch presigned URL on click and preview -->
          <div class="relative group">
            <lib-image-preview #savedPreview [images]="getSavedAttachmentImages(attachment)" title="Cheque Image">
              <button
                type="button"
                class="flex h-18 w-18 flex-col items-center justify-center gap-1 rounded-lg border-0 bg-surface-0 text-surface-500 hover:bg-surface-100"
                pTooltip="View image"
                (click)="$event.stopPropagation(); viewSavedAttachment(attachment, savedPreview)"
              >
                @if (loadingAttachmentId() === attachment.documentId) {
                  <i class="pi pi-spin pi-spinner text-lg"></i>
                } @else {
                  <i class="pi pi-eye text-lg"></i>
                  <span class="text-xs">View</span>
                }
              </button>
            </lib-image-preview>
            <button
              type="button"
              class="absolute -top-1.5 -right-1.5 flex h-5 w-5 border-none items-center justify-center rounded-full bg-red-500 text-white shadow opacity-0 group-hover:opacity-100 transition-opacity"
              (click)="removeAttachment(attachment)"
            >
              <i class="pi pi-times text-xs"></i>
            </button>
          </div>
        }
      }
    </div>

    <input
      #chequeFileInput
      type="file"
      class="hidden"
      accept="image/*"
      multiple
      (change)="onChequeFilesSelected($event)"
    />
  </div>

  <div class="flex justify-end gap-2 mt-2">
    <p-button type="button" label="Cancel" severity="secondary" (onClick)="onCancel()" />
    <p-button type="submit" label="Save" [disabled]="form.invalid" />
  </div>
</form>
